import moment from 'moment';

import {
  FieldsEnum,
  FormsEnum,
  SteeringWheelLocationEnum,
} from 'app/shared/enums';
import {
  getCarData,
  getCepikDataFromSelector,
  getQuotationWithCepikDataFromSelector,
  getIsMotorFromSelector,
  setQuestionVisibility,
} from 'app/services/businessFunctionHelpers';

export function getShouldHideDrivingWheelLocation() {
  const cepikCarData = getCepikDataFromSelector();
  const quotationWithCepikData = getQuotationWithCepikDataFromSelector();
  const { make, model, productionYear } = getCarData();

  if (!cepikCarData || !quotationWithCepikData) return false;

  const hasDrivingWheelLocationLeftFromCepik =
    quotationWithCepikData.car?.drivingWheelLocation ===
    SteeringWheelLocationEnum.Left;

  const hasProductionYearChanged =
    cepikCarData.productionYear.length === 1 &&
    cepikCarData.productionYear[0].key !== productionYear;

  const hasMakeChanged =
    cepikCarData.make.length === 1 && cepikCarData.make[0].key !== make;

  const hasModelChanged =
    cepikCarData.model.length === 1 && cepikCarData.model[0].key !== model;

  const shouldHideDrivingWheelLocationQuestion =
    hasDrivingWheelLocationLeftFromCepik &&
    !hasProductionYearChanged &&
    !hasMakeChanged &&
    !hasModelChanged;

  return shouldHideDrivingWheelLocationQuestion;
}

export function setDrivingWheelLocationVisibility() {
  const isMotor = getIsMotorFromSelector();
  const cepikCarData = getCepikDataFromSelector();
  const {
    firstRegistrationCountry,
    firstRegistrationDate,
    ownerPurchaseYear,
  } = getCarData();

  if (!cepikCarData || !ownerPurchaseYear || isMotor) return;

  const firstRegistrationDateYear = moment(firstRegistrationDate).year();
  const carOwnerPurchaseYear = Number(ownerPurchaseYear);
  const showCarDrivingWheelLocationFor = ['eur', 'other'];

  const shouldHideDrivingWheelLocation = getShouldHideDrivingWheelLocation();

  const isCarDrivingWheelLocationVisible =
    showCarDrivingWheelLocationFor.includes(firstRegistrationCountry) &&
    Boolean(
      !shouldHideDrivingWheelLocation &&
        firstRegistrationDateYear &&
        carOwnerPurchaseYear &&
        firstRegistrationDateYear !== carOwnerPurchaseYear
    );

  if (isCarDrivingWheelLocationVisible) {
    setQuestionVisibility({
      key: FieldsEnum.CarDrivingWheelLocation,
      visible: true,
      formName: FormsEnum.CalculationForm,
    });
  }
}
